import auth from './auth';
import dashboard from './dashboard';
import statistics from './statistics';

export const ApiRepository = {
  auth,
  dashboard,
  statistics
};
